import { cva, type VariantProps } from 'class-variance-authority';
import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import { cn } from '../lib/cn';

const alert = cva(
  'flex items-start gap-[10px] rounded-wc-lg border px-[14px] py-3 text-[13px] font-medium leading-[1.5]',
  {
    variants: {
      tone: {
        info: 'bg-selected text-accent border-wc-blue-20',
        success: 'bg-tint-success text-tint-success-text border-tint-success-border',
        warning: 'bg-tint-warning text-tint-warning-text border-tint-warning-border',
        error: 'bg-tint-error text-tint-error-text border-tint-error-border',
      },
    },
    defaultVariants: { tone: 'info' },
  },
);

const ICONS = {
  info: Info,
  success: CircleCheck,
  warning: TriangleAlert,
  error: CircleAlert,
} as const;

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Obrigatorio: define icone, cor e se o leitor de tela interrompe. */
  tone: NonNullable<VariantProps<typeof alert>['tone']>;
  title?: string;
}

export function Alert({ className, tone, title, children, ...props }: AlertProps) {
  const Icon = ICONS[tone];
  return (
    <div
      // Erro e aviso interrompem; informacao e sucesso esperam a vez do leitor.
      role={tone === 'error' || tone === 'warning' ? 'alert' : 'status'}
      className={cn(alert({ tone }), className)}
      {...props}
    >
      <Icon size={16} strokeWidth={1.5} aria-hidden="true" className="mt-px shrink-0" />
      <div>
        {title !== undefined && <strong className="font-bold">{title} </strong>}
        {children}
      </div>
    </div>
  );
}
